import waypoint from 'waypoints/lib/jquery.waypoints.min';
import inview from 'waypoints/lib/shortcuts/inview.min';
import { counter, lazyload } from './page';

export function active_section()
{
	let waypoints = $('[data-wp]').waypoint({
		handler: function (direction) {
			let _this = $(this)[0]['element'];
			let active_section = $(_this);

			if( $(_this).hasClass('impact') )
			{
				if( !$(_this).hasClass('active') )
				{
					counter(_this);
				}
			}

			if( !active_section.hasClass('active') )
			{
				lazyload(active_section);
			}

			active_section.addClass('active');
		},
		offset: '70%',
	});
}




// WEBPACK FOOTER //
// ./scripts/modules/waypoints.js